import { render, staticRenderFns } from "./simpleSeeCode.vue?vue&type=template&id=5513b8b8&scoped=true"
import script from "./simpleSeeCode.vue?vue&type=script&lang=js"
export * from "./simpleSeeCode.vue?vue&type=script&lang=js"
import style0 from "./simpleSeeCode.vue?vue&type=style&index=0&id=5513b8b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5513b8b8",
  null
  
)

export default component.exports